<div class="bg-cover bg-center bg-no-repeat item-center text-white md:h-[500px] p-2 md:p-24 bg-gray-500" [ngStyle]="{'background-image': 'url(' + tenant.getImg(tenant.GIVEAWAYS) + ')'}">
	<div class="md:max-w-[50%] text-center md:text-left">
		<p class="text-xl md:text-md font-bold mb-6"><span class="uppercase">{{this.tenant.getName()}} FIELD ACCESS</span> PREMIUM GIVEAWAYS</p>
		<h2 class="text-4xl md:text-5xl font-bold text-white mb-4">
			Want to experience game day like never before?
		</h2>
		<p class="text-2xl">
			{{this.tenant.getName()}} subscribers get the chance to win exclusive on-field access at $STADIUM_NAME and beyond!
		</p>
	</div>
</div>